import '../stylesheets/themes/bemingressos.scss'

const images = require.context('../images/bemingressos', true)
